module.exports = __webpack_public_path__ + "static/media/cut.1f67f267.png";